import type { ReactElement } from 'react';

export interface RfqPdfSidePanelProps {
  title: string;
  blobUrl: string;
  onClose: () => void;
  /** `below` = full-width strip under the vendor quote tables (default). */
  variant?: 'below';
}

/** PDF viewer for vendor quote attachments (object URL from authenticated fetch). */
export function RfqPdfSidePanel({ title, blobUrl, onClose, variant = 'below' }: RfqPdfSidePanelProps): ReactElement {
  const shellClass =
    variant === 'below' ? 'rfq-pdf-slide-panel' : 'rfq-pdf-side-panel';

  return (
    <aside className={shellClass} aria-label="Quote attachment preview">
      <div className="rfq-pdf-side-panel-header">
        <h4 className="rfq-pdf-side-panel-title">{title}</h4>
        <button type="button" className="icon-close" onClick={onClose} aria-label="Close attachment panel">
          ×
        </button>
      </div>
      <div className="rfq-pdf-side-panel-body">
        <iframe title={title} src={blobUrl} className="rfq-pdf-iframe" />
      </div>
    </aside>
  );
}
